import { useState } from "react";
import Alert from "react-bootstrap/Alert";

export default function HolidayAlert() {
  // If the alert has been dismissed, do not show it
  if (sessionStorage.getItem("holidayAlertDismissed") === "true") {
    return null;
  }

  const handleDismiss = () => {
    sessionStorage.setItem("holidayAlertDismissed", "true");
  };

  return (
    <Alert
      variant='info'
      className='text-center mb-0 w-100'
      dismissible
      onClose={handleDismiss}
    >
      ✨<strong>Happy New Year!</strong>✨
      <br />
      We're back to our regular Reachback support schedule.
    </Alert>
  );
}
